import LocationOnIcon from "@mui/icons-material/LocationOn";
import MailIcon from "@mui/icons-material/Mail";
import "./header.css";
import templeJson from "../../../../config/temple.json";
import { Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import LoginIcon from "@mui/icons-material/Login";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLoginFunctions } from "../CustomHook";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";

function TopHeader() {

  const {
    hasToken,
    showDropdown,
    devoteeData,
    dropdownRef,
    currentUrlPath,
    toggleDropdown,
    handleLogout,
  } = useLoginFunctions();
  return (
    <>
      <Grid
        className={templeJson["Header"].style == 1 ? "dt-header" : "svt-header"}
        style={
          templeJson["Header"].style == 1
            ? {}
            : {
                backgroundImage: `url(
                  ${process.env.REACT_APP_S3_BASE_URL}/api/images/header.jpg
                )`,
              }
        }
      >
        <Grid className="container">
          <Grid container className="gx-0">
            {templeJson["Header"].style == 1 ? (
              <>
                <Grid item lg={6} className="text-center text-lg-start mb-lg-0">
                  <Grid className="d-flex flex-wrap">
                    <Link to="/" className="text-light me-4">
                      <LocationOnIcon className="top-icon" /> {templeJson["templeAddress"]}
                    </Link>
                    <Link to="/" className="text-light me-0">
                      <MailIcon className="top-icon" /> {templeJson["contactEmail"]}
                    </Link>
                  </Grid>
                </Grid>
                <Grid item lg={3} className="text-right text-lg-end">
                  <ul className="header-icon-list">
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        className="top-icon"
                        href={templeJson["youtubeLink"]}
                      >
                        <YouTubeIcon />
                      </a>
                    </li>
                    <li>
                      <a
                        href={templeJson["facebookLink"]}
                        rel="noreferrer"
                        target="_blank"
                        className="top-icon"
                      >
                        <FacebookIcon />
                      </a>
                    </li>
                    <li>
                      <a
                        href={templeJson["instagramLink"]}
                        rel="noreferrer"
                        className="top-icon"
                        target="_blank"
                      >
                        <InstagramIcon />
                      </a>
                    </li>
                  </ul>
                </Grid>
                <Grid item lg={3} className="text-center text-lg-end">
                  {hasToken ? (
                    <div className="d-flex align-items-center justify-content-end">
                      <div className="dropdown" ref={dropdownRef}>
                        <Button
                          className="btn dropdown-toggle text-profile"
                          type="button"
                          onClick={toggleDropdown}
                        >
                          <AccountCircleIcon className="top-icon" />{" "}
                          {devoteeData?.first_name}
                        </Button>
                        {showDropdown && (
                          <ul
                            className="dropdown-menu show"
                            aria-labelledby="dropdownMenuButton"
                            style={{ zIndex: 2000 }}
                          >
                            <li>
                              <Link className="dropdown-item" to="/">
                                Dashboard
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/profile">
                                Profile
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/changepassword"
                              >
                                Change Password
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/report">
                                Report
                              </Link>
                            </li>

                            <li>
                              <Button
                                className="dropdown-item"
                                onClick={handleLogout}
                              >
                                Logout
                              </Button>
                            </li>
                          </ul>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-end">
                      <Link
                        to={`/login?redirect=${currentUrlPath}`}
                        className="text-light me-0"
                      >
                        <LoginIcon className="top-icon" /> Login
                      </Link>
                    </div>
                  )}
                </Grid>
              </>
            ) : (
              <Grid style={{ margin: "0 auto" }}>
                <Link to="/">
                  <Grid>
                    <img
                      src={
                        process.env.REACT_APP_S3_BASE_URL +
                        "/api/images/header3.png"
                      }
                      alt="logo"
                      className="svt-logo"
                    />
                  </Grid>
                </Link>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default TopHeader;
